import { getEDDFormat, getFieldsFromDateAsFormatCustom } from './getFieldsFromDateAsFormatCustom';

export function getDateRange({
  eddLower,
  eddUpper,
  showDateSpecifically = false,
  isPDPhase2Enabled = false,
  isRushEnabled = false,
  deliverySLA = ''
}) {
  if (!eddLower && !eddUpper) {
    return null;
  }
  if (!eddLower) {
    const {
      dd: ddUpper,
      month3Val: month3ValUpper,
      time: timeUpper
    } = getFieldsFromDateAsFormatCustom(eddUpper);
    let dateRange = `${ddUpper} ${month3ValUpper}`;
    if (
      (isRushEnabled || isPDPhase2Enabled) &&
      (deliverySLA.includes('HR') || deliverySLA.includes('MIN'))
    ) {
      dateRange += `, ${timeUpper}`;
    }
    return dateRange;
  }
  const {
    dd: ddLower,
    month3Val: month3ValLower,
    time: timeLower
  } = getFieldsFromDateAsFormatCustom(eddLower);
  const {
    dd: ddUpper,
    month3Val: month3ValUpper,
    time: timeUpper
  } = getFieldsFromDateAsFormatCustom(eddUpper);
  if (ddLower === ddUpper && month3ValLower === month3ValUpper) {
    let dateRange = `${ddLower} ${month3ValLower}`;
    if (
      timeLower === timeUpper &&
      (isRushEnabled || isPDPhase2Enabled) &&
      (deliverySLA.includes('HR') || deliverySLA.includes('MIN'))
    ) {
      dateRange += `, ${timeLower}`;
    }
    return dateRange;
  }
  if (month3ValLower === month3ValUpper && !showDateSpecifically) {
    return `${ddLower} - ${ddUpper} ${month3ValUpper}`;
  }
  return `${ddLower} ${month3ValLower} - ${ddUpper} ${month3ValUpper}`;
}

export function getDateRangeRefresh({
  eddLower,
  eddUpper,
  showDateSpecifically = false,
  isPDPhase2Enabled = false,
  isRushEnabled = false,
  deliverySLA = ''
}) {
  if (!eddLower && !eddUpper) {
    return null;
  }
  if (!eddLower) {
    const {
      dd: ddUpper,
      month3Val: month3ValUpper,
      day: dayUpper,
      time: timeUpper
    } = getFieldsFromDateAsFormatCustom(eddUpper);
    let dateRange = `${dayUpper}, ${ddUpper} ${month3ValUpper}`;
    if (
      (isRushEnabled || isPDPhase2Enabled) &&
      (deliverySLA.includes('HR') || deliverySLA.includes('MIN'))
    ) {
      dateRange += `, ${timeUpper}`;
    }
    return dateRange;
  }
  const {
    dd: ddLower,
    month3Val: month3ValLower,
    day: dayLower,
    time: timeLower
  } = getFieldsFromDateAsFormatCustom(eddLower);
  const {
    dd: ddUpper,
    month3Val: month3ValUpper,
    day: dayUpper,
    time: timeUpper
  } = getFieldsFromDateAsFormatCustom(eddUpper);
  if (ddLower === ddUpper && month3ValLower === month3ValUpper) {
    let dateRange = `${dayLower}, ${ddLower} ${month3ValLower}`;
    if (
      timeLower === timeUpper &&
      (isRushEnabled || isPDPhase2Enabled) &&
      (deliverySLA.includes('HR') || deliverySLA.includes('MIN'))
    ) {
      dateRange += `, ${timeLower}`;
    }
    return dateRange;
  }
  if (month3ValLower === month3ValUpper && !showDateSpecifically) {
    return `${ddLower} - ${ddUpper} ${month3ValUpper}`;
  }
  return `${ddLower} ${month3ValLower} - ${ddUpper} ${month3ValUpper}`;
}

export function getDateRangeForGA({ eddLower, eddUpper }) {
  if (!eddLower && !eddUpper) return null;
  if (!eddLower) return getEDDFormat(eddUpper);
  if (eddLower === eddUpper) return getEDDFormat(eddLower);
  const lowerDate = getEDDFormat(eddLower);
  const upperDate = getEDDFormat(eddUpper);
  if (lowerDate && upperDate) return `${lowerDate} - ${upperDate}`;
  if (lowerDate) return lowerDate;
  if (upperDate) return upperDate;
  return '';
}
